import React from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';

import { EventInfo, EventInfoWithoutPlayers } from '@/api/events/types/types';
import { LiveIcon } from '@/assets/icons/live-indicator';
import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { designSystem } from '@/styles/styles';
import { EventAttributesType, EventStatus } from '@/types/api.generated';
import { findEventAttribute } from '@/utils/fantasy-attribute-utils';
import { gameUtils } from '@/utils/games';

export const WIDTH = 240;
export const HEIGHT = 146;

export const PGAEventCard = ({
    event,
    onPress,
    isSelected,
}: {
    event: EventInfo | EventInfoWithoutPlayers;
    onPress: () => void;
    isSelected?: boolean;
}) => {
    const title = gameUtils.createHeaderTitleLabel(event);
    const roundNumber = findEventAttribute(event, EventAttributesType.RoundNumber) ?? '';
    const isLive = event.status === EventStatus.InProgress;
    return (
        <TouchableOpacity onPress={onPress}>
            <Row
                borderRadius={'r12'}
                borderWidth={1}
                style={isSelected ? styles.selectedContainer : styles.container}
                paddingHorizontal={'s12'}
                paddingVertical={'s10'}
                alignItems={'center'}
            >
                {isLive ? (
                    <Box mr={'s4'}>
                        <LiveIcon size={14} />
                    </Box>
                ) : null}
                <Text variant={'titleSmall'} style={isSelected ? styles.selectedTitle : styles.title}>
                    {title}
                </Text>
                {roundNumber ? (
                    <Text variant={'bodySmall'} color={isSelected ? ds.colorToken.text.secondary : 'neutral300'}>
                        {` • R${roundNumber}`}
                    </Text>
                ) : null}
            </Row>
        </TouchableOpacity>
    );
};

const styles = StyleSheet.create({
    container: {
        borderColor: ds.colorValue.border.subtle,
        backgroundColor: ds.colorValue.background.neutral.base,
    },
    selectedContainer: {
        borderColor: ds.colorValue.border.subtle,
        backgroundColor: ds.colorValue.background.neutral.subtler,
    },
    selectedTitle: {
        color: ds.colorValue.text.primary,
    },
    title: {
        color: designSystem.colors.neutral300,
    },
});
